import React from 'react'
import CareersBanner from '../../components/CareersComponents/CareersBanner'
import JoinOurTeam from '../../components/CareersComponents/JoinOurTeam'
import JobOpenings from '../../components/CareersComponents/JobOpenings'

const Careers = () => {
    return (
        <>
            <CareersBanner />
            <JoinOurTeam />
            <JobOpenings />
        </>
    )
}

export default Careers
